import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './RoomsDashboard.css';

function RoomsDashboard({ user }) {
  const [rooms, setRooms] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        setIsLoading(true);
        const response = await fetch('/api/rooms', {
          credentials: 'include'
        });
        
        if (!response.ok) {
          throw new Error('Failed to fetch rooms');
        }
        
        const data = await response.json();
        setRooms(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchRooms();
  }, []);

  const joinRoom = (roomName) => {
    navigate(`/room/${roomName}`);
  };

  const openBellaKiosk = () => {
    navigate('/bella-kiosk');
  };

  return (
    <>
      <div className="dashboard-container">
        <h2>MyJava Active Rooms</h2>
      
      {error && <div className="error-message">{error}</div>}
      
      {isLoading ? (
        <div className="loading">Loading rooms...</div>
      ) : (
        <div className="rooms-grid">
          {rooms.length > 0 ? (
            rooms.map(room => (
              <div 
                key={room.id} 
                className={`room-card ${room.attendees >= room.capacity ? 'room-full' : 'room-available'}`}
                onClick={() => room.attendees < room.capacity && joinRoom(room.name)}
              >
                <h3 className="room-name">{room.name}</h3>
                <div className="room-details">
                  <span className="room-capacity">
                    Attendees {room.attendees}/{room.capacity}
                  </span>
                  <span className="room-created">
                    Created: {new Date(room.created_at).toLocaleDateString()}
                  </span>
                </div>
                
                {/* Show speaking indicator for all rooms initially */}
                <div className="speaking-now">
                  <span className="speaking-text">Speaking Now</span>
                  <span className="speaking-indicator">
                    <span className="wave wave1"></span>
                    <span className="wave wave2"></span>
                    <span className="wave wave3"></span>
                  </span>
                </div>
                
                {room.attendees >= room.capacity ? (
                  <div className="room-status full">Room Full</div>
                ) : (
                  <div className="room-status available">Available</div>
                )}
              </div>
            ))
          ) : (
            <div className="no-rooms">No active rooms found</div>
          )}
        </div>
      )}
      </div>
      
      {user && user.role === 'admin' && (
        <div className="dashboard-container kiosk-demo-container">
          <h2>Kiosk Demo</h2>
          <div className="rooms-grid">
            <div 
              className="room-card room-available kiosk-card"
              onClick={openBellaKiosk}
            >
              <h3 className="room-name">Bella</h3>
              <div className="room-details">
                <span className="room-capacity">
                  AVAILABLE
                </span>
              </div>
              <div className="room-status available">Click to Demo</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default RoomsDashboard;